import { useState } from 'react'
import { SystemSS } from '../../../components/SystemSS'
import { FullScreenModal } from '../../../utility/FullScreenModal'
export const FacilitiesGadgets = () => {
    const [showModal, setShowModal] = useState(false)
    const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 1 })
    const handleOpenModal = (contentType, category, index, maxIndex) => {
        setModalContent({ contentType, category, index, maxIndex })
        setShowModal(true)
        console.log('clickd')
    }
    const handleCloseModal = () => {
        setModalContent({ contentType: '', category: '', index: 0 })
        setShowModal(false)
    }
    return (
        <>
            <section className=''>
                <div className='flex justify-center '>
                    <img
                        className=''
                        alt='confine'
                        src={`${process.env.PUBLIC_URL}/images/system/system-gadgets.webp`}
                    />
                </div>
                <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full md:w-4/5 px-4 md:px-0 mx-auto mt-12'>
                    <p>
                        <span className='text-pborange'>Create</span> and <span className='text-pborange'>power up</span> Gadgets to summon on the battlefield!
                    </p>{' '}<br/>
                    <p>
                        Use Gadgets you’ve created to <span className='text-pborange'>destroy</span> blocks, <span className='text-pborange'>bring items</span> to you, and perform special actions in battle, providing many different ways to tackle each map! 
                    </p>
                    <SystemSS
                        mediaItems={[
                            {
                                modalId: 'facilitiesgadget',
                                index: 1,
                            },
                        ]}
                        handleOpenModal={handleOpenModal}
                       
                    />{' '}
                </div>
            </section>{' '}
            <FullScreenModal
                showModal={showModal}
                modalContent={modalContent}
                setModalImage
                handleCloseModal={handleCloseModal}
                setModalContent={setModalContent}
                maxIndex={1}
            />
        </>
    )
}
